import { Control, Controller } from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import i18n from 'i18n';
import { FormLabel } from '../../form-label';
import LOCALS from 'commons/locals';
import { Input } from 'antd';

const GuestRemarks = ({
  control,
  index,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
}) => {
  return (
    <div className="flex items-center gap-2">
      <FormLabel className="self-start">
        {i18n.t(LOCALS.guest_remarks)}:
      </FormLabel>
      <Controller
        name={`productList.${index}.guestRemarks`}
        control={control}
        render={({ field }) => (
          <Input.TextArea
            {...field}
            maxLength={100}
            placeholder={i18n.t('show_to_the_guest') || ''}
            showCount
          />
        )}
      />
    </div>
  );
};

export default GuestRemarks;
